export function animateElement(element, keyframes, options = {}) {
  if (!element) {
    return Promise.resolve();
  }

  const finalFrame = keyframes[keyframes.length - 1] || {};

  if (typeof element.animate !== 'function') {
    applyFrame(element, finalFrame);
    return Promise.resolve();
  }

  const animation = element.animate(keyframes, {
    fill: 'both',
    ...options,
  });

  return animation.finished
    .catch(() => { })
    .then(() => {
      applyFrame(element, finalFrame);
      animation.cancel();
    });
}

function applyFrame(element, frame) {
  Object.entries(frame).forEach(([property, value]) => {
    if (['offset', 'easing', 'composite'].includes(property)) {
      return;
    }

    element.style[property] = value;
  });
}

export function fadeIn(element, options = {}) {
  return animateElement(
    element,
    [
      { opacity: 0 },
      { opacity: 1 },
    ],
    options
  );
}

export function fadeOut(element, options = {}) {
  return animateElement(
    element,
    [
      { opacity: 1 },
      { opacity: 0 },
    ],
    options
  );
}

function transitionOffset(transition, opening) {
  const offsets = {
    'transition.slideUpIn': {
      opening: 'translateY(100%)',
    },
    'transition.slideDownOut': {
      closing: 'translateY(100%)',
    },
    'transition.slideUpBigIn': {
      opening: 'translateY(100%)',
      closing: 'translateY(-100%)',
    },
    'transition.slideDownBigIn': {
      opening: 'translateY(-100%)',
    },
    'transition.slideDownBigOut': {
      closing: 'translateY(100%)',
    },
    'transition.slideRightBigIn': {
      opening: 'translateX(-100%)',
    },
    'transition.slideRightBigOut': {
      closing: 'translateX(100%)',
    },
  };

  const config = offsets[transition];

  if (!config) {
    return null;
  }

  return opening ? config.opening : config.closing;
}

export function animateNamedTransition(
  element,
  transition,
  {
    opening = true,
    duration = 250,
    delay = 0,
    easing = 'ease-out',
  } = {}
) {
  if (!element) {
    return Promise.resolve();
  }

  const offset = transitionOffset(transition, opening);

  if (!offset) {
    return opening
      ? fadeIn(element, { duration, delay, easing })
      : fadeOut(element, { duration, delay, easing });
  }

  const keyframes = opening
    ? [
      { opacity: 0, transform: offset },
      { opacity: 1, transform: 'none' },
    ]
    : [
      { opacity: 1, transform: 'none' },
      { opacity: 0, transform: offset },
    ];

  return animateElement(element, keyframes, {
    duration,
    delay,
    easing,
  });
}
